import { Subject } from 'rxjs'

export enum TerminalEventType {
    OnSwitchTerminal,
}

export type TerminalEventMessage = {
    eventType: TerminalEventType.OnSwitchTerminal
    /** new client ID */
    data: string
}

const terminalEvent = new Subject<TerminalEventMessage>()

export default terminalEvent
